import { useMemberListStore } from "@stores/useMemberListStore";
import { IClient } from "./../pages/auth/login/index";
import { Observable } from "rxjs";
import { useLabsStore } from "@stores/labsStore";
import { post, get } from "@utils/axios";
import sessionService from "./session.service";
import { usenextkinInfoStore } from "@stores/nextkinInfoStore";
import { usePopulationInsightStore } from "@stores/populationInsightStore";
import { useRecommendationDataStore } from "@stores/useRecommendationDataStore";
import { useCareCoordinationStore } from "@stores/useCareCoordinationStore";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { useDashboardStore } from "@stores/dashboardStore";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import { useHighCostPatientStore } from "@stores/highCostPatientStore";
import { useHighIntensityProgramStore } from "@stores/highIntensityStore";
import { useConfigStore } from "@stores/useConfigStore";
import { useDurableStore } from '@stores/useDurableStore';
import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import { useGenericTableStore } from "@stores/useGenericTableStore";
import { useMeasuresStore } from "@stores/measuresStore";
import { useDynamicFormStore } from "@stores/dynamicFormStore";
import { useContactDetailsForCoordinatorStore } from "@stores/contactDetailsForCoordinatorStore";
import { useDataQualityReportStore } from "@stores/dataQualityReport";
import { useMemberDetailsStore } from "@stores/memberDetailsStore";
import { useChronicBreakdownStore } from "@stores/chronicBreakdownStore";
class AuthService {
  private base: string = `${process.env.REACT_APP_API_BASE_URI}/users`;

  healthCheck(client: IClient): Observable<any> {
    return get(`${client.appServiceUrl}/health-check`);
  }

  login(credentials: any, client: IClient): Observable<any> {
    return post(`${client.appServiceUrl}/users/v1/login`, credentials, {
      headers: { "Content-Type": "application/json" },
    });
  }

  getmfaqrcode(credentials: any, client: IClient): Observable<any> {
    return post(`${client.appServiceUrl}/users/v1/getmfaqrcode`, credentials, {
      headers: { "Content-Type": "application/json" },
    });
  }

  logout(): Observable<any> {
    useHospitalMappingStore.getState().clearStore();
    useMemberListStore.getState().clearStore();
    useMemberDetailsStore.getState().clearStore();
    usenextkinInfoStore.getState().clearStore();
    usePopulationInsightStore.getState().clearStore();
    useMeasuresStore.getState().clearStore();
    useChronicBreakdownStore.getState().clearStore();
    useDashboardStore.getState().clearStore();
    usePatientProfileStore.getState().clearStore();
    useRecommendationDataStore.getState().clearStore();
    useCareCoordinationStore.getState().clearStore();
    useGlobalInformationStore.getState().clearStore();
    useHighCostPatientStore.getState().clearStore();
    useHighIntensityProgramStore.getState().clearStore();
    useConfigStore.getState().clearStore();
    useLabsStore.getState().clearStore();
    useDurableStore.getState().clearStore();
    useGenericTableStore.getState().clearStore();
    useDynamicFormStore.getState().clearStore();
    useContactDetailsForCoordinatorStore.getState().clearStore();
    useDataQualityReportStore.getState().clearStore();
    return post(`${sessionService.getClient()?.appServiceUrl}/users/logout`);
  }

  refreshToken(refreshToken:any): Promise<any> {
    return post(`${sessionService.getClient()?.appServiceUrl}/users/v1/refreshToken`, {},
      {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    }).toPromise();
  }

  forgetPassword(email: any, client: IClient): Observable<any> {
    return post(`${client.appServiceUrl}/users/v1/forgot-password`, { email: email.email, domain_id: client.domain_id });
  }

  resetPassword(password: any, confirmPassword: any, token: any, client: IClient): Observable<any> {
    return post(
      `${client?.appServiceUrl}/users/reset-password`,
      { password: password, confirmPassword: confirmPassword },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  }

  getMeData(): Observable<any> {
    return get(`${sessionService.getClient()?.appServiceUrl}/users/v1/me`);
  }
}

export default new AuthService();
